module.exports = __webpack_public_path__ + "static/media/smartflow-white.c7aa3df3.png";